import gql from 'graphql-tag';

const DELETE_COMPANY_MUTATION = gql`
    mutation companyDelete ($id: ID!) {
        companyDelete (id: $id)
    }
`;

export default DELETE_COMPANY_MUTATION;